
<div style="z-index: 4;" >
    <div class="input-wrapper slected-input" (click)="toggleDropDown()" #myInput [ngClass]="data['allocatedVehicle'].length==0?'disabled':''">
        <p>{{data['allocatedVehicle'].length==0?'No Data':selectedValue}}</p>
        <img src="assets/drop-down-arrow.svg" alt="" class="arrow" [ngClass]="{'open-arrow': open,'close-arrow':!open}"/>
    </div>

        <div class="dropdown-wrapper" [ngClass]="{'open': open,'close':!open}" #dropdown>
            <div class="dropdown-container">
                <div class="option-wrapper">
                    <span class="label">{{eligibleVehicleLable}}</span>
                    <div *ngFor="let item of data['allocatedVehicle']" (click)="optionClicked(item,'allocated')"><span>{{item}}</span></div>
                    <span class="label split-head">{{OtherVehicle}}</span>
                    <div *ngFor="let item of data['allVehicle']" (click)="optionClicked(item,'all')"><span>{{item}}</span></div>
                    <ng-container *ngIf="data['highCapacity']?.length">
                    <div *ngFor="let item of data['highCapacity']" (click)="optionClicked(item,'allocated')"><span>{{item}}</span></div>
                </ng-container>
                    <div *ngIf="data['allVehicle']?.length==0 && data['highCapacity']?.length==0">
                            <span style="color: #929DAB;">No Cabs</span>
                    </div>
                </div>
            </div>
        </div>
</div>

<app-popover *ngIf="openPopup"  (closeCallback)="openPopup=false" size="addCaboption-model">
    <div popover-header class="popover-header font-weight-700">
        <img src="assets/ic-ui-warning-24.svg" alt="">
       <span class="ml-12 fs-20 font-weight-700"> Warning</span></div>
    <div popover-content class="add-costcenter-container">
            <span>You have requested for a vehicle for which you are not eligible.<br>
                Do you still wish to proceed?</span>
    </div>
    <div popover-actions class="submit-button">
        <app-button type="plainText" text="Cancel" class="mr-20" (clickCallback)="openPopup=false"
          ></app-button>
        <app-button type="primaryFilled" text="Proceed" (clickCallback)="proceedWithNonAllocatedVechicle()"
          [btnType]="'successBtn'"></app-button>
      </div>
</app-popover>

    
<div class="overlay" [ngClass]="{'open-overlay': open,'close-overlay':!open}" (click)="toggleDropDown()"></div>
